var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelopePurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 6.25a5 5 0 0 1 5 5v17.5a5 5 0 0 1-5 5h-25a5 5 0 0 1-5-5l.002-17.047-.002-.046v-.407l.003-.042.005-.252a5 5 0 0 1 4.698-4.698L7.5 6.25h25zm2.5 9.737-12.378 7.617a5 5 0 0 1-5.244 0L5 15.99v12.76a2.5 2.5 0 0 0 2.26 2.489l.24.011h25a2.5 2.5 0 0 0 2.5-2.5V15.987zM32.5 8.75h-25a2.5 2.5 0 0 0-2.5 2.5v.407a2.5 2.5 0 0 0 1.188 2.128l12.5 7.69a2.5 2.5 0 0 0 2.624 0l12.5-7.691A2.5 2.5 0 0 0 35 11.655v-.405l-.011-.24A2.5 2.5 0 0 0 32.5 8.75z",
    fill: "#821BB8",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopePurple);
export default __webpack_public_path__ + "static/media/envelope-purple.72d63e3dfc336e3f260b7b933fd47951.svg";
export { ForwardRef as ReactComponent };